import type { WirelessReceiverLink } from "kubb";
import {
  AssetRegisterListHeading,
  DenseAssetRegisterListItem,
} from "pages/assetRegister/AssetRegisterListPage/AssetRegisterListItem";
import type React from "react";
import List from "../../../../../components/List/List";
import { formatDate } from "../../../../../components/utils/HighlightNullAndOldDates";

interface Props {
  history: Array<WirelessReceiverLink>;
}

function ReceiverHistoryListItem(
  item: WirelessReceiverLink,
  _refresh?: () => void,
): React.ReactElement {
  const { location, asset_position, asset, created_on, deleted_on } = item;

  return DenseAssetRegisterListItem({
    assetRegisterItem: {
      location,
      asset_position,
      asset,
      install_date: created_on,
      uninstall_date: deleted_on,
    },
    showType: false,
    showScheme: false,
    column2: () => (
      <>
        {formatDate(created_on)} -{" "}
        {deleted_on ? formatDate(deleted_on) : "present"}
      </>
    ),
    column3: () => <></>,
    column1Size: "w-3/4",
    column2Size: "w-1/4",
    column3Size: "d-none",
  });
}
function ReceiverHistoryTable(props: Props) {
  return (
    <List
      row={ReceiverHistoryListItem}
      header={
        <AssetRegisterListHeading
          column1Size={"w-3/4"}
          column2Size={"w-1/4"}
          column3Size={"d-none"}
          column1={"Receiver"}
          column2={"Assignment Times"}
          column3={""}
        />
      }
      data={props.history}
    />
  );
}

export default ReceiverHistoryTable;
